import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html'

})
export class UserDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
